import { File } from './file';
import { Author } from './author';
import { Source } from './source.enum';

export class Storyboard {
  id: string;
  parentId: string;
  name: string;
  displayName: string;
  author?: Author;
  createdTime: number;
  updateDate: number;
  size?: number;
  
  files: Array<File>;
  thumbnailFileId?: string;
  source: Source;

  constructor(
    id: string,
    parentId: string,
    name: string,
    displayName: string,
    author: Author,
    createdTime: number,
    size: number,
    files: Array<File>
  ) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.displayName = displayName;
    this.author = author;
    this.createdTime = createdTime;
    this.size = size;
    this.files = files;
    this.source = Source.Storyboard;
  }
}
